<template>
    <div
        class="device-card"
        @click="handleClick"
    >
        <div class="device-part">
            <div class="title-content">
                <div class="left">
                    <img
                        v-if="iconUrl"
                        :src="iconUrl"
                        :alt="deviceTitle"
                        @error="handleImageError"
                    />
                    <span class="title" :title="deviceInfo.title">
                        {{ deviceTitle  }}
                    </span>
                </div>
                <span class="icon-arrow-right-1 more-icon"></span>
            </div>
        </div>
        <div class="combo-content">
            <template v-if="currentSubscription">
                <div class="combo-title">
                    {{$t('current_plan')}}:
                </div>
                <OneLineText
                    class="plan-info"
                    :text="$tc('dashboard.plan_subscribed', undefined,{
                        planName: ['', undefined, null].includes(deviceInfo.planTitle)? $t('dashboard.unknow_plan'): deviceInfo.planTitle
                    })"
                />
                <div class="combo-info">
                    <span>{{ $t('dashboard.device_detail.valid_until')}}</span>
                    <span>{{ subscriptionActive? formatTime(currentSubscription.endingAt,$t,'12') :$t('dashboard.device_detail.main_card.expired')}}</span>
                </div>
            </template>
            <template v-else>
                <div class="combo-no-sub">
                    {{ $t('dashboard.device_detail.no_plan') }}
                </div>
            </template>
        </div>
    </div>
</template>
<script lang="ts">
import Vue, { PropType } from 'vue';
import { IReolinkDeviceWithSubscription } from '@reolink-cloud/interface';
import { uidHandler } from '@/lib/uidHandler';
import OneLineText from '@/components/OneLineText.vue';
import DefaultDeviceIcon from 'IMAGE/dashboard/device.png';
import { formatTime } from '@/utils/time';
import reolinkGa from '@/common/js/gtagPageview';

export default Vue.extend({
    components: {
        OneLineText
    },
    props: {
        deviceInfo: {
            type: Object as PropType<IReolinkDeviceWithSubscription>,
        },
    },
    mounted() {

        this.getDeviceIcon();

    },
    methods: {
        formatTime,
        async handleClick(): Promise<void> {

            if ( this.deviceInfo.status === 'unassociated' ) {

                reolinkGa.sendSimpleEvent( 'Devices-Cloud-No Plan Active' );

            }
            await this.$router.push({ path: '/user/my-device', query: { ymh: uidHandler.encrypt( this.deviceInfo.uid ) } });

        },
        getDeviceIcon() {

            let urlPart = '';
            urlPart += encodeURIComponent( this.deviceInfo.model );
            this.iconUrl = `https://home-cdn.reolink.us/wp-content/assets/app/model-images/${urlPart}/product.png`;

        },
        handleImageError() {

            // 当图片加载失败时，使用默认图片
            // 防止无限循环：只有当前不是默认图片时才切换到默认图片
            if ( this.iconUrl !== DefaultDeviceIcon ) {

                this.iconUrl = DefaultDeviceIcon;

            }

        }
    },
    data() {

        return {
            iconUrl: null as null | string,
            DefaultDeviceIcon
        };

    },
    computed: {
        currentSubscription(): IReolinkDeviceWithSubscription['subscriptionDetail'] {

            return this.deviceInfo.subscriptionDetail;

        },
        subscriptionActive(): boolean {

            return this.currentSubscription?.status === 'active';

        },
        deviceTitle(): string {

            if ( this.deviceInfo.title !== '' ) {

                return this.deviceInfo.title;

            }
            return this.deviceInfo.modelTitle;

        }
    }
});
</script>
<style lang="less" scoped>
.device-card {
    box-sizing: border-box;
    cursor: pointer;
    border: 2px solid transparent;
    transition: border 1s;
    padding: 16px;
    border-radius: @border-radius-level-2;
    background-color: @bg_02;
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-width: 0;

    &:hover{
        border: 2px solid @b_6;
    }

    span {
        white-space: pre;
    }

    .device-part {
        box-sizing: border-box;
        &>.title-content + .device-info {
            margin-top: 12px;
        }
        .title-content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .left{
                display: flex;
                align-items: center;
                gap: 8px;
                max-width: 90%;
                .title {
                    font-family: @font_02;
                    font-weight: 500;
                    letter-spacing: 0em;
                    color: @font_primary;
                    font-size: 16px;
                    white-space: normal;
                    text-overflow: ellipsis;
                    max-width: 100%;
                    white-space: nowrap;
                    overflow: hidden;
                    min-width: 0;
                    flex-grow: 0;
                }

                img{
                    width: 40px;
                }
            }

            /deep/ .ac-checkbox .check-icon{
                border-radius: 0;
                border: 3px solid @font_disable;
            }

            /deep/ .radio .check-icon{
                border-radius: 100%;
                border-width: 4px;
            }

            .more-icon{
                color: @font_primary;
                font-size: 24px;
            }
        }
        .checkbox-disable{
            /deep/ .ac-checkbox .check-icon{
                border-radius: 0;
                border: none;
                background-color: @disable;
            }
        }
        .device-info {
            display: flex;
            align-items: center;
            margin-bottom: 4px;
            &:last-of-type{
                margin-bottom: 0;
            }
            span {
                font-family: @font_02;
                font-weight: 500;
                letter-spacing: 0em;
                font-size: 14px;
                line-height: 18px;
            }
            span:last-of-type {
                color: @font_primary;
            }
            span:first-of-type {
                color: rgba(255, 255, 255, 0.6);
            }
        }

    }
    .combo-content {
        box-sizing: border-box;
        background-color: @bg_03;
        padding: 12px;
        flex: 1;
        &>.combo-title + .combo-info {
            margin-top: 12px;
            margin-bottom: 4px;
        }

        .combo-title {
            font-family: @font_02;
            font-weight: 500;
            letter-spacing: 0em;
            color: @font_secondary;
            font-size: 14px;
            line-height: 21px;
        }
        .combo-info{
            display: flex;
            align-items: center;
            color: @font_secondary;
            font-size: 12px;
            font-weight: 500;
            line-height: 18px;
        }
        .plan-info{
            font-size: 16px;
            font-weight: 500;
            line-height: 24px;
            .mobile({
                font-size: 14px;
                line-height: 21px;
            });
        }
        .combo-no-sub {
            font-family: @font_02;
            font-size: 14px;
            font-weight: 600;
            line-height: 18px;
            letter-spacing: 0em;
            color: @font_secondary;
            height: 100%;
            flex: 1;
        }
    }

}
</style>
